module.exports = __webpack_public_path__ + "img/gb13871-92_85x120x12.prt.180e9058.jpg";